import React from 'react';
import { Button } from '../components/ui/button';
import { Instagram, Facebook, Youtube, Music, FolderOpen } from 'lucide-react';
import { SOCIAL } from '../mock';

export default function CTA() {
  return (
    <section id="cta" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] rounded-full bg-violet-600/15 blur-[140px]" />

      <div className="relative max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <div className="inline-flex items-center gap-3 font-mono text-[11px] tracking-[0.3em] text-cyan-300/80 uppercase mb-6">
          <span className="h-px w-10 bg-cyan-400/50" />
          <span>// Ready to Book</span>
          <span className="h-px w-10 bg-cyan-400/50" />
        </div>
        <h2 className="font-display text-6xl md:text-7xl lg:text-8xl leading-[0.9] mb-8">
          <span className="block text-white">LET YKAS</span>
          <span className="block text-gradient-purple italic">FEEL YOUR</span>
          <span className="block text-white">RHYTHM</span>
        </h2>
        <p className="text-white/60 text-base md:text-lg max-w-xl mx-auto mb-10 leading-relaxed font-body">
          Whether it's a wedding in Mumbai, a rooftop birthday, or a podcast mix heard around the world — DJ YKAS will make it unforgettable.
        </p>
        <div className="flex flex-wrap gap-3 justify-center">
          <Button asChild className="bg-cyan-400 text-[#05030c] hover:bg-cyan-300 rounded-sm font-mono text-[11px] tracking-[0.25em] uppercase h-12 px-8">
            <a href={SOCIAL.instagram} target="_blank" rel="noreferrer">DM on Instagram</a>
          </Button>
          <Button asChild variant="outline" className="bg-transparent border-violet-400/40 text-violet-100 hover:bg-violet-500/10 hover:text-violet-100 rounded-sm font-mono text-[11px] tracking-[0.25em] uppercase h-12 px-8">
            <a href={SOCIAL.drive} target="_blank" rel="noreferrer">View Press Kit</a>
          </Button>
        </div>
      </div>
    </section>
  );
}

const SOCIAL_ITEMS = [
  { icon: Instagram, href: SOCIAL.instagram, label: 'Instagram' },
  { icon: Facebook, href: SOCIAL.facebook, label: 'Facebook' },
  { icon: Music, href: SOCIAL.soundcloud, label: 'SoundCloud' },
  { icon: Youtube, href: SOCIAL.youtube, label: 'YouTube' },
];

export function Footer() {
  return (
    <footer className="relative border-t border-violet-500/10 py-10">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex flex-col items-center md:items-start">
          <div className="font-display text-2xl tracking-wider text-violet-300 leading-none">DJ YKAS</div>
          <div className="font-mono text-[10px] tracking-[0.25em] text-violet-400/50 mt-1">FEEL THE RHYTHM · MUMBAI</div>
        </div>
        <div className="flex items-center gap-4">
          {SOCIAL_ITEMS.map((s) => {
            const Ic = s.icon;
            return (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                aria-label={s.label}
                className="w-10 h-10 rounded-sm border border-violet-400/25 bg-violet-950/20 flex items-center justify-center text-white/60 hover:text-cyan-300 hover:border-cyan-400/50 hover:bg-cyan-950/20 transition-colors"
              >
                <Ic size={16} />
              </a>
            );
          })}
          <a
            href={SOCIAL.drive}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 font-mono text-[10px] tracking-[0.25em] text-cyan-300/70 hover:text-cyan-200 uppercase px-3 h-10 border border-cyan-400/25 rounded-sm bg-cyan-950/10"
          >
            <FolderOpen size={13} /> 150+ Mixes
          </a>
        </div>
        <div className="font-mono text-[10px] tracking-[0.2em] text-white/30 uppercase">
          © {new Date().getFullYear()} DJ YKAS · All Rights Reserved
        </div>
      </div>
    </footer>
  );
}
